import { useEffect, useRef } from 'react';
import styles from '../../styles/renewal/OnePage.module.css';

/**
 * 섹션 등장 애니메이션.
 *
 * 시안은 scroll/resize 리스너에 더해 120ms setInterval 로 위치를 폴링했다.
 * 같은 동작을 IntersectionObserver 로 바꿔 유휴 상태에서 타이머가 돌지 않게 한다.
 * 반환된 ref 를 감싸는 요소에 붙이면 그 안의 `.reveal` 요소를 관찰한다.
 */
export default function useReveal() {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const targets = Array.from(root.querySelectorAll(`.${styles.reveal}`));
    const show = (el) => el.classList.add(styles.revealed);

    if (typeof IntersectionObserver === 'undefined') {
      targets.forEach(show);
      return undefined;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          show(entry.target);
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.04 }
    );

    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return rootRef;
}
